import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Snowflake, Loader2, CheckCircle2, Lock } from "lucide-react";
import { toast } from "sonner";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (!token) toast.error("Link non valido"); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Minimo 6 caratteri"); return; }
    if (pw !== pw2) { toast.error("Le due password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (e) {
      toast.error("Reset fallito", { description: e?.response?.data?.detail || "Riprova." });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-white border border-sky-100 rounded-2xl p-8">
        <div className="w-12 h-12 rounded-xl bg-sky-50 grid place-items-center mb-4">
          {done ? <CheckCircle2 className="w-6 h-6 text-emerald-600" /> : <Lock className="w-5 h-5 text-sky-700" />}
        </div>
        {done ? (
          <>
            <h1 className="font-heading text-2xl text-[#032B44]">Password aggiornata</h1>
            <p className="text-sm text-slate-600 mt-2">
              Puoi accedere ora con la tua nuova password.
            </p>
            <Link to="/" className="inline-block mt-6">
              <Button className="bg-[#032B44] hover:bg-[#00A3FF] text-white" data-testid="reset-done-home">
                Torna alla home
              </Button>
            </Link>
          </>
        ) : !token ? (
          <>
            <h1 className="font-heading text-2xl text-[#032B44]">Link non valido</h1>
            <p className="text-sm text-slate-600 mt-2">
              Questo link di reset non è valido. Richiedi un nuovo reset dal modulo di login.
            </p>
          </>
        ) : (
          <>
            <h1 className="font-heading text-2xl text-[#032B44]">Nuova password</h1>
            <p className="text-sm text-slate-600 mt-2">
              Scegli una nuova password di almeno 6 caratteri.
            </p>
            <form onSubmit={submit} className="mt-6 space-y-3">
              <Input
                type="password"
                required
                placeholder="Nuova password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                className="h-11"
                data-testid="reset-pw"
              />
              <Input
                type="password"
                required
                placeholder="Conferma password"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                className="h-11"
                data-testid="reset-pw2"
              />
              <Button type="submit" disabled={busy} className="w-full h-11 bg-[#032B44] hover:bg-[#00A3FF] text-white" data-testid="reset-submit">
                {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Salvataggio…</> : "Aggiorna password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
